import React from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { drapcodeIcon } from '../../common/custom/icon-library';
import {
  menuItemsForAppConstant,
  getAppSettingBasePath,
  isAppSettingActive,
  isDeletePermissionActive,
} from '../../common/utils/api_utils';

const AdvanceAppConstant = ({ projectDetail }) => {
  const { pathname } = useLocation();
  const { projectId, version } = useParams();

  const dropdownColor =
    menuItemsForAppConstant.some((item) =>
      isAppSettingActive(pathname, item.key, version, projectId),
    ) || isDeletePermissionActive(pathname, version, projectId)
      ? 'theme-green--dropdown'
      : 'theme-primary--dropdown';

  return (
    <UncontrolledDropdown group>
      <DropdownToggle color={dropdownColor} title="Advanced" className="btn-md" caret>
        <i className={`wb ${drapcodeIcon('advanced')}`}></i> Advanced
      </DropdownToggle>
      <DropdownMenu>
        {menuItemsForAppConstant.map((item) => {
          if (item.requiresProjectDetail && !projectDetail) return null;
          const to = getAppSettingBasePath(item.key, version, projectId);
          const activeClass = isAppSettingActive(pathname, item.key, version, projectId)
            ? 'active'
            : '';

          return (
            <DropdownItem
              key={item.key}
              tag={Link}
              to={to}
              className={`theme-primary ${activeClass}`}
            >
              {item.directIcon ? (
                <i className={`wb ${item.icon}`}></i>
              ) : (
                <i className={`wb ${drapcodeIcon(item.icon)}`}></i>
              )}
              &nbsp;{item.label}
            </DropdownItem>
          );
        })}
        <DropdownItem
          key="Delete Permission"
          tag={Link}
          to={`/permission/${version}/v/${projectId}`}
          className={`theme-primary ${
            isDeletePermissionActive(pathname, version, projectId) ? 'active' : ''
          }`}
        >
          <i className={`wb ${drapcodeIcon('delete')}`}></i>
          &nbsp;Delete Permission&nbsp;
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default AdvanceAppConstant;
